import { MAX_COACH_INPUT_CHARS } from "@/hooks/use-coach";

/**
 * Strip C0 control chars (except tab/newline), trim, and cap length.
 * Shared sanitizer for any free-text value that flows into the coach or a
 * related persistence surface (reflections, saved titles).
 *
 * Returns `null` when the cleaned string is empty — callers use that signal
 * to disable coaching buttons. Callers that always want a string can use
 * `sanitizeCoachInputOrEmpty`.
 */
export function sanitizeCoachInput(
  raw: string,
  cap: number = MAX_COACH_INPUT_CHARS,
): string | null {
  const cleaned = raw
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u0008\u000B-\u001F\u007F]/g, "")
    .trim();
  if (!cleaned) return null;
  return cleaned.slice(0, cap);
}

export function sanitizeCoachInputOrEmpty(
  raw: string,
  cap: number = MAX_COACH_INPUT_CHARS,
): string {
  return sanitizeCoachInput(raw, cap) ?? "";
}
